import { baseApi } from "api/BaseApi";

import { Scheme } from "./schemes.types";

const SCHEMES_BASE_QUERY = "/account/scheme";

const schemesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getFrontendProducersConsumers: build.query<Scheme[], void>({
      query: () => ({
        url: `${SCHEMES_BASE_QUERY}/get_frontend_producers_consumers/`,
      }),
    }),
    getFrontendProducersConsumersCount: build.query<number, void>({
      query: () => ({
        url: `${SCHEMES_BASE_QUERY}/get_frontend_producers_consumers/`,
      }),
      transformResponse: (response: {
        consumers: Scheme[];
        producers: Scheme[];
      }) => response.consumers.length + response.producers.length,
    }),
  }),
});

export const {
  useGetFrontendProducersConsumersQuery,
  useGetFrontendProducersConsumersCountQuery,
} = schemesApi;
